import { FetchesData } from "kinnect-mixins";
import {
	KAddressFormBox,
	KDatePicker,
	KForm,
	KPhoneField,
	KSelect,
	KTextField,
	KTextarea
} from "kinnect-general";
import { ServiceType } from "kinnect-models";

export default KForm.extend( {
	name: "KServiceForm",

	props: {
		redirect: {
			...KForm.options.props.redirect,
			default: () => [ "back", { name: "services" } ]
		},

		service: Object
	},

	mixins: [ FetchesData ],

	data: () => ( {
		formFields: {
			address: null,
			city: null,
			email: null,
			idServiceType: null,
			lat: null,
			lng: null,
			model: null,
			modelNumber: null,
			name: null,
			notes: null,
			phone: null,
			purchaseDate: null,
			serialNumber: null,
			state: null,
			zip: null
		},
		today: ( new Date() ).setHours( 0, 0, 0, 0 ),
		users: null
	} ),

	computed: {
		editing() {
			return Boolean( this.service );
		},

		formUrl() {
			return this.editing ? `services/${this.service.id}` : "services";
		}
	},

	watch: {
		service: {
			handler( service ) {
				if ( service ) {
					Object.keys( this.formFields ).forEach( key => {
						if ( service.hasOwnProperty( key ) ) {
							this.formFields[key] = service[key];
						}
					} );
				}
			},
			immediate: true
		}
	},

	methods: {
		async fetchServiceTypes() {
			this.serviceTypes = await ServiceType.get();
		},

		async fetch() {
			await this.fetchServiceTypes();
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: this.formUrl,
				data: this.formFields,
				method: this.editing ? "put" : "post"
			}}
			on={this.$listeners}
		>
			<KTextField
				label="Customer Name*"
				prependIcon="person"
				required
				vModel={this.formFields.name}
				validationName="customer name"
				validationRules="required"
			></KTextField>

			<KAddressFormBox
				address={this.formFields.address}
				city={this.formFields.city}
				class="mb-4 ml-blank-icon mt-2"
				lat={this.formFields.lat}
				lng={this.formFields.lng}
				on={{
					"update:address": val => this.formFields.address = val,
					"update:city": val => this.formFields.city = val,
					"update:lat": val => this.formFields.lat = val,
					"update:lng": val => this.formFields.lng = val,
					"update:state": val => this.formFields.state = val,
					"update:zip": val => this.formFields.zip = val
				}}
				required
				state={this.formFields.state}
				zip={this.formFields.zip}
			></KAddressFormBox>

			<KPhoneField
				label="Phone Number"
				vModel={this.formFields.phone}
				validationName="phone"
				validationRules="phone"
			></KPhoneField>

			<KTextField
				label="Email"
				prependIcon="email"
				type="email"
				vModel={this.formFields.email}
				validationName="email"
				validationRules="email"
			></KTextField>

			<KTextField
				class="ml-blank-icon"
				label="Model"
				vModel={this.formFields.model}
			></KTextField>

			<KTextField
				class="ml-blank-icon"
				label="Model Number"
				vModel={this.formFields.modelNumber}
			></KTextField>

			<KTextField
				class="ml-blank-icon"
				label="Serial Number"
				name="serialNumber"
				vModel={this.formFields.serialNumber}
			></KTextField>

			<KDatePicker
				textFieldProps={{
					label: "Purchase Date*",
					required: true,
					validationName: "purchase date",
					validationRules: "required"
				}}
				vModel={this.formFields.purchaseDate}
			></KDatePicker>

			<KSelect
				class="ml-blank-icon"
				itemText="name"
				itemValue="id"
				items={this.serviceTypes}
				label="Status*"
				loading={this.$wait.is( "get service types" )}
				required
				vModel={this.formFields.idServiceType}
				validationName="status"
				validationRules="required"
			></KSelect>

			<KTextarea
				label="Notes"
				prependIcon="comment"
				vModel={this.formFields.notes}
			></KTextarea>
		</KForm>;
	}
} );
